import React, {useState }  from 'react';
import "./img.css";
import { motion } from "framer-motion";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./about.css";
import "./consult.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Footer from './footer';
import LatestUpdates from "./latestupdates";
import Consultants from './consult.js';

const About = () => {
    return (
        <>
            {/* Breadcrumb Section */}
            <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
                    <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
                        About Us
                    </h3>
                    <ol className="breadcrumb justify-content-center text-white mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item">
                            <Link to="/" className="text-white">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="#" className="text-white">Pages</Link>
                        </li>
                        <li className="breadcrumb-item active text-secondary">About</li>
                    </ol>
                </div>
            </div>

            {/* About Section */}
            <div className="container-fluid overflow-hidden py-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        {/* Image Section */}
                        <div className="col-xl-5 wow fadeInLeft" data-wow-delay="0.1s">
                            <div className="bg-light rounded">
                                <img src="img/about-2.png" className="img-fluid w-100" alt="About Us" />
                                <img 
                                    src="img/about-3.jpg" 
                                    className="img-fluid w-100 border-bottom border-5 border-primary rounded-top" 
                                    style={{ borderTopRightRadius: '300px', borderTopLeftRadius: '300px' }} 
                                    alt="Company Overview"
                                />
                            </div>
                        </div>

                        {/* Content Section */}
                        <div className="col-xl-7 wow fadeInRight" data-wow-delay="0.3s">
                            <h5 className="sub-title">About the company</h5>
                            <h1 className="display-5 mb-4">We’re Trusted Immigration Consulting Agency.</h1>
                            <p className="mb-4">
                                Bajwa Immigration Consultants specialize in guiding students and professionals in their journey to Australia. 
                                With expertise in education and migration services, our trained staff assists in selecting the right courses, 
                                securing visas, and ensuring a seamless transition.  
                                <br /><br />
                                With over <strong>75,000+</strong> admissions, <strong>50,000+</strong> temporary residencies, and <strong>50,000+</strong> PR approvals, 
                                our track record speaks for itself. We understand that each client’s needs are unique, and we provide personalized guidance 
                                from admissions to permanent residency, making your immigration process smooth and stress-free.
                            </p>

                            {/* Key Features */}
                            <div className="row gy-4">
                                <div className="col-12 col-sm-6 d-flex align-items-center">
                                    <i className="fas fa-map-marked-alt fa-3x text-secondary"></i>
                                    <h5 className="ms-3">Best Immigration Resources</h5>
                                </div>
                                <div className="col-12 col-sm-6 d-flex align-items-center">
                                    <i className="fas fa-passport fa-3x text-secondary"></i>
                                    <h5 className="ms-3">Return Visas Available</h5>
                                </div>
                            </div>

                            {/* Experience & Services */}
                            <div className="row mt-4">
                                <div className="col-4 col-md-3">
                                    <div className="bg-light text-center rounded p-3">
                                        <i className="fas fa-ticket-alt fa-4x text-primary mb-2"></i>
                                        <h1 className="display-5 fw-bold">19</h1>
                                        <p className="text-muted">Years of Experience</p>
                                    </div>
                                </div>
                                <div className="col-8 col-md-9">
                                    <div className="mb-4">
                                        <p className="text-primary h6">
                                            <i className="fa fa-check-circle text-secondary me-2"></i> 100% Genuine Assistance
                                        </p>
                                        <p className="text-primary h6">
                                            <i className="fa fa-check-circle text-secondary me-2"></i> Fast & Reliable Execution
                                        </p>
                                        <p className="text-primary h6">
                                            <i className="fa fa-check-circle text-secondary me-2"></i> Accurate & Expert Advice
                                        </p>
                                    </div>

                                    {/* Contact Section */}
                                    <div className="d-flex align-items-center">
                                        <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
                                            <a href="tel:+01234567890" className="position-relative wow tada" data-wow-delay=".9s">
                                                <i className="fa fa-phone text-primary fa-3x"></i>
                                                <span className="position-absolute" style={{ top: '0', left: '25px' }}>
                                                    <i className="fa fa-comment-dots text-secondary"></i>
                                                </span>
                                            </a>
                                        </div>
                                        <div className="d-flex flex-column">
                                            <span className="text-primary">Have any questions?</span>
                                            <span className="text-secondary fw-bold fs-5" style={{ letterSpacing: '2px' }}>
                                            Free: +61 406 401 000
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div> 
                </div>
            </div>
            <div className="container-fluid bg-primary text-white text-center py-5">
            <Container>
            <h2 
    className="mb-4 wow fadeInDown" 
    data-wow-delay="0.1s" 
    style={{ color: "#e02454 " }}  // Change to your preferred color
>
                    Now You Can Book Your Appointment Online With Us!
                </h2>
                <p className="mb-4 wow fadeInDown" data-wow-delay="0.2s">
                    Schedule your consultation with our experts in just a few clicks. Get professional guidance for your immigration journey.
                </p>
                <Button 
                    href="https://au.bajwaimmigration.com/book-appointment"
                    variant="light"
                    size="lg"
                    className="fw-bold px-4 py-2 wow fadeInUp"
                    data-wow-delay="0.3s"
                >
                    Book Now
                </Button>
                <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 start-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>
            </Container>
        </div><br/>
       <Consultants/>
        <LatestUpdates/>

            <Footer />
        </>
    );
};
export default About;



